{
  "ACTIONS": {
    "CONFIRM": "Bestätigen",
    "CONTINUE": "Weiter",
    "SUBMIT": "Einreichen",
    "RETRY": "Erneut versuchen",
    "CANCEL": "Abbrechen",
    "EMPTY": "Sie haben keine Bestellungen",
    "LOADING_ORDERS": "Ihre Rechnung wird vorbereitet",
    "CLEAR_ALL": "Alle löschen",
    "AWESOME": "Großartig!",
    "VIEW_RECEIPT": "Die Quittung",
    "ADD_CART": "Zum Warenkorb hinzufügen",
    "UPDATE_CART": "Warenkorb aktualisieren",
    "EDIT": "Bearbeiten",
    "SEARCH_PLACEHOLDER": "Suche nach Lebensmitteln oder Restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Es fehlen einige Optionen, bitte wählen Sie diese aus, bevor Sie fortfahren",
    "ITEM_UNAVAILABLE": "Dieser Artikel ist derzeit nicht verfügbar",
    "SECTION_NOT_FOUND": "Dieser Bereich ist nicht mehr verfügbar",
    "ITEM_NOT_FOUND": "Dieser Artikel ist nicht mehr verfügbar",
    "PROMOTION_NOT_AVAILABLE": "Dieses Angebot ist nicht mehr verfügbar",
    "REQUIRED": "Erforderlich",
    "COMBO": "Combo",
    "INVALID_EMAIL": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "INVALID_PHONE": "Bitte geben Sie eine gültige Telefonnummer ein",
    "FEES": "Gebühren",
    "MIN_ORDER_ERROR": "Mindestbestellwert von {{currency}} {{amount}} ist erforderlich, um Ihre Bestellung aufzugeben",
    "ADD_MIN_ORDER": " Fügen Sie {{currency}} {{amount}}, um Ihre Bestellung aufzugeben",
    "CONNECTION_ERROR": "Beim Laden dieses Tisches ist etwas schiefgelaufen. Bitte versuchen Sie es erneut.",
    "TABLE_NOT_FOUND": "Wir konnten diesen Tisch nicht finden. Bitte scannen Sie den QR-Code erneut."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Nachname",
    "ROOM_NUMBER": "Zimmernummer",
    "SNACKBAR_TITLE": "Ihre Quittung ist auf dem Weg!",
    "PAY_BILL": "Rechnung bezahlen"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Gesamtzahl der Personen am Tisch",
    "PAYING_FOR": "Gesamtzahl der Personen, für die Sie bezahlen",
    "REMAINING": "Restbetrag",
    "CHEQUE": "Rechnung",
    "AMOUNT_PAID": "Bezahlter Betrag",
    "DISCOUNT": "Rabatt",
    "PROMO": "Aktion",
    "FEES": "Gebühren",
    "PAID_ITEMS": "Bezahlte Artikel",
    "SPLIT_BILL": "Rechnung teilen",
    "EDIT_SPLIT": "Aufteilung bearbeiten",
    "PAY_BILL": "Rechnung bezahlen",
    "SPLIT_TITLE": "Rechnung teilen",
    "SPLIT_SUBTITLE": "Wählen Sie, wie Sie die Rechnung aufteilen möchten",
    "SPLIT_EVENLY": "Gleichmäßig aufteilen",
    "CUSTOM_AMOUNT": "Individueller Betrag",
    "ADD_CUSTOM_AMOUNT": "Individuellen Betrag hinzufügen",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Individuellen Betrag eingeben",
    "PAY_FOR_ITEMS": "Ihre Artikel bezahlen",
    "CONFIRM_SELECTION": "Auswahl bestätigen",
    "SOMEONE_ELSE_PAYING": "Jemand anderes an Ihrem Tisch bezahlt gerade"
  },
  "COMBO": {
    "ADD_N": "{{count}} {{section}} hinzufügen",
    "REMOVE_N": "{{count}} {{section}} entfernen",
    "CANNOT_PROCEED": "Bitte folgen Sie der Anleitung oben, um Ihre Combo zu vervollständigen, bevor Sie fortfahren",
    "COMPLETE": "{{combo}}-Combo vollständig!",
    "ON_ANOTHER_SECTION": "Dies ist Teil Ihrer {{section}}-Combo"
  },
  "CART": {
    "TITLE": "Warenkorb",
    "RECOMMENDATION": "Das könnte dir auch gefallen",
    "TOTAL": "Insgesamt",
    "VIEW": "Warenkorb ansehen & Bestellung aufgeben",
    "EMPTY": "Leer",
    "PLACE_ORDER": "Bestellung aufgeben",
    "ADD_TO_BILL": "Zur Rechnung hinzufügen",
    "PAY_NOW": "Jetzt bezahlen",
    "OOPS": "Ups",
    "ADD_NEW_VARIANT": "Weiteren hinzufügen",
    "VARIANT_TITLE": "Meinung geändert?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Sind Sie sicher, dass Sie den Warenkorb löschen wollen?",
    "CLEAR": "Warenkorb löschen",
    "ADD_NOTE": "Notiz hinzufügen",
    "NOTE_LABEL": "Notiz"
  },
  "PAYMENT": {
    "CONFIRMED": "Ihre Bestellung wurde bezahlt!",
    "ERROR": "Bei der Zahlung ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
    "APPLE_PAY_TAP_AGAIN": "Bitte tippen Sie erneut auf Apple Pay, um fortzufahren",
    "TITLE": "Zahlung",
    "PAY_CARD": "Kasse",
    "SUCCESSFUL": "Die Zahlung war erfolgreich",
    "SUMMARY": "Zusammenfassung der Zahlungen",
    "PROGRESS": "Zahlung in Bearbeitung..., bitte warten",
    "CANCEL": "Bitte aktualisieren Sie diese Seite nicht und klicken Sie nicht auf die Schaltfläche Zurück. Wenn Sie den Vorgang abbrechen möchten, drücken Sie bitte die Abbruchtaste am Zahlungsautomaten."
  },
  "ORDER": {
    "TITLE": "Meine Bestellungen",
    "CONFIRMED": "Bestätigt",
    "NOTES": "Anmerkungen zur Bestellung",
    "TOTAL": "Insgesamt",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Bestellung",
    "PAID": "Bezahlt",
    "PLACED": "Ihre Bestellung wurde aufgegeben",
    "UNPAID": "Ihre Bestellung ist unbezahlt",
    "CANCELLED": "Ihre Bestellung wurde storniert",
    "VOID": "Ihre Bestellung wurde annulliert",
    "UPDATED": "Ihre Bestellung wurde aktualisiert",
    "ORDERS": "Bestellungen",
    "PREVIOUS": "Bisherige Bestellungen",
    "REJECTED": "Huch! Ein oder mehrere Artikel oder Modifikatoren sind derzeit nicht verfügbar und wurden aus Ihrem Warenkorb entfernt."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "Wir sind in Kürze für Sie da",
    "HELP": "Wie können wir helfen?",
    "ADDITIONAL_COMMENTS": "Anmerkungen"
  },
  "MENU": {
    "SKIP": "Überspringen",
    "MENU": "Menu",
    "SEARCH": "Suche",
    "NO_SEARCH_RESULTS": "Keine Artikel entsprechen Ihrer Suche",
    "SEARCH_OTHER_SECTIONS": "Wir haben Treffer in anderen Bereichen gefunden",
    "NO_FILTER_RESULTS": "Keine Artikel entsprechen Ihren Filtern",
    "CLEAR_FILTERS": "Filter zurücksetzen",
    "NO_SECTIONS": "Keine Bereiche verfügbar",
    "STAFF": "Personal anrufen",
    "FILTERS": "Diät Filter"
  },
  "SETTINGS": {
    "TITLE": "Einstellungen",
    "LANGUAGE": "Sprache",
    "SELECT_LANGUAGE": "Sprache auswählen",
    "CURRENCY": "Währung"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Anrechnung auf mein Zimmer"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Bitte scannen Sie den QR erneut, um Ihre Sitzung fortzusetzen.",
    "SESSION_EXPIRED": "Ihre Sitzung ist abgelaufen"
  },
  "PICKUP": {
    "TITLE": "Deine Details"
  },
  "VOUCHER": {
    "ADD": "Einen Gutschein hinzufügen",
    "PLACEHOLDER": "Geben Sie Ihren Gutschein ein",
    "VOUCHER": "Gutschein",
    "DISCOUNTED_AMOUNT": "Gesamtbetrag nach Rabatt",
    "CURRENT_BALANCE": "Guthaben",
    "REMAINING_BALANCE": "Guthaben nach Kauf",
    "AMOUNT_DUE": "Fälliger Betrag"
  },
  "TIP": {
    "TIP": "Trinkgeld",
    "ADD": "Trinkgeld hinzufügen",
    "PLACEHOLDER": "Trinkgeldbetrag eingeben"
  },
  "LANDING": {
    "CALL_WAITER": "Kellner rufen",
    "VIEW_BILL": "Rechnung ansehen - ",
    "LOADING_BILL": "Rechnung wird geladen"
  },
  "LOADER": {
    "Heading": "Ihre Zahlung wird verarbeitet...",
    "Subheading": "Bitte schließen Sie diese Seite nicht. Wir bestätigen Ihre Zahlung und leiten Sie automatisch weiter.",
    "Hint": "Das dauert normalerweise nur wenige Sekunden."
  },
  "NoVoucher": "Gutschein nicht verfügbar",
  "VoucherDisabled": "Dieser Gutschein ist deaktiviert",
  "VoucherExpired": "Dieser Gutschein ist abgelaufen",
  "VoucherAlreadyUsed": "Dieser Gutschein wurde bereits verwendet",
  "VoucherZeroBalance": "Dieser Gutschein hat ein Guthaben von 0",
  "VoucherUserLimitReached": "Sie haben diesen Gutschein bereits verwendet",
  "VoucherFirstOrderOnly": "Dieser Gutschein gilt nur für Ihre erste Bestellung",
  "VoucherNotApplicable": "Dieser Gutschein gilt nicht für die Artikel in Ihrer Bestellung"
}
